const parseOptionalBoolean = (raw: string | undefined): boolean | undefined => {
  if (raw == null) return undefined;
  const normalized = raw.trim().toLowerCase();
  if (normalized === 'true' || normalized === '1') return true;
  if (normalized === 'false' || normalized === '0') return false;
  return undefined;
};

/**
 * `VITE_ENABLE_GAMEPLAY_HISTORY_REPLAY`: when unset, defaults to dev-on / prod-off.
 */
export function resolveGameplayHistoryReplayEnabled(
  raw: string | undefined,
  devDefault: boolean,
): boolean {
  return parseOptionalBoolean(raw) ?? devDefault;
}
